module.exports = __webpack_public_path__ + "img/pop_up_manuello.b549a36f.jpg";